import dayjs from "dayjs";

export interface LoadedStay {
  listingId?: string;
  fromDate: Date | null;
  untilDate: Date | null;
  adultsCount: number;
  childrenCount: number;
  petsCount: number;
}

// A stay is the listing plus the dates and guests it's priced for. Keys are only
// compared to decide whether the store needs reloading, so a false mismatch just
// costs an extra fetch.
export const getUrlStayKey = (search: string): string | null => {
  const params = new URLSearchParams(search);
  const listingId = params.get("listingId");
  const fromDate = params.get("fromDate");
  const untilDate = params.get("untilDate");
  const adultsCount = params.get("adultsCount");

  if (
    listingId == null ||
    fromDate == null ||
    untilDate == null ||
    adultsCount == null
  ) {
    return null;
  }

  return [
    listingId,
    fromDate,
    untilDate,
    Number(adultsCount),
    Number(params.get("childrenCount") ?? 0),
    Number(params.get("petsCount") ?? 0),
  ].join("|");
};

export const getLoadedStayKey = (stay: LoadedStay): string | null => {
  if (
    stay.listingId == null ||
    stay.fromDate == null ||
    stay.untilDate == null
  ) {
    return null;
  }

  return [
    stay.listingId,
    dayjs(stay.fromDate).format("YYYY-MM-DD"),
    dayjs(stay.untilDate).format("YYYY-MM-DD"),
    stay.adultsCount,
    stay.childrenCount,
    stay.petsCount,
  ].join("|");
};
